import { render, staticRenderFns } from "./NavigationMenu.vue?vue&type=template&id=131f94c0&scoped=true"
import script from "./NavigationMenu.vue?vue&type=script&lang=js"
export * from "./NavigationMenu.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenu.vue?vue&type=style&index=0&id=131f94c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131f94c0",
  null
  
)

export default component.exports